export default __webpack_public_path__ + "static/media/K2700Gallery2.42eb34b3.jpg";